const Loader = () => {
  return (
    <div className="bubbles">
      <span></span>
      <span id="bubble2"></span>
      <span id="bubble3"></span>
    </div>
  );
};

export default Loader;
